import { render } from "./SocialDashboard.vue?vue&type=template&id=387551b8&scoped=true"
import script from "./SocialDashboard.vue?vue&type=script&lang=js"
export * from "./SocialDashboard.vue?vue&type=script&lang=js"

import "./SocialDashboard.vue?vue&type=style&index=0&id=387551b8&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387551b8"]])

export default __exports__